import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import { ArtistPage } from './routes/artist';
import { IndexPage } from './routes/index';
import { SearchSchema } from './state/search';

const rootRoute = createRootRoute({ component: () => <Outlet /> });

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
});

export const artistRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/a/$artistId',
  validateSearch: (search: Record<string, unknown>) => SearchSchema.parse(search),
  component: ArtistPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([indexRoute, artistRoute]),
  defaultPreload: false,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
